<template>
  <v-layout wrap>
     <vue-element-loading
      :active="appLoading"
      :is-full-screen="true"
      background-color="#FFFFFF"
      color="#FDAC53"
      spinner="bar-fade-scale"
    />
    <v-layout v-if="ServerError" wrap justify-center>
      <v-flex px-5 pt-5 xs12 sm12 md12 lg12 xl12 text-center>
        <ServerError />
      </v-flex>
    </v-layout>
    <v-flex py-4 py-lg-6 class="head" text-center>Hivekeep Blog</v-flex>
    <v-flex xs12 px-lg-16>
      <v-layout wrap px-lg-16>
        <v-flex sm6 md6>
          <v-card tile>
            <v-img height="500px">
              <!-- src="../../assets/images/waterdrop.jpg" -->
              <v-layout wrap pa-md-16 pa-3 fill-height pt-12>
                <v-flex xs6 md6 lg3 pb-lg-7 class="clr">LATEST UPDATE </v-flex>
                <v-flex xs6 md6 lg3 pb-lg-7 class="regulartext clr"
                  >2 hours ago
                </v-flex>
                <v-flex xs12 md12 lg10 style="color: black" class="subhead"
                  >{{ blog.heading }}
                </v-flex>
                <v-flex xs3 align-self-end pb-7 pb-md-0>
                  <v-layout wrap>
                    <v-flex xs5 text-left>
                      <v-icon :disabled="firstItem ? true : false"
                        @click="show()" large color="#D0D0D5"
                        >mdi-arrow-left-circle-outline</v-icon
                      >
                    </v-flex>
                    <v-flex xs5 text-right
                      ><v-icon @click="showImage()"
                        :disabled="lastItem ? true : false" large color="#D0D0D5"
                        >mdi-arrow-right-circle-outline</v-icon
                      >
                    </v-flex>
                  </v-layout>
                </v-flex>
                <v-flex xs8 align-self-end text-right pb-7 pb-md-0>
                  <v-icon large color="#D0D0D5">mdi-share-variant</v-icon>
                </v-flex>
              </v-layout>
            </v-img>
          </v-card>
        </v-flex>
        <v-flex sm6 md6>
          <v-card tile>
            <v-img height="500px" :src="mediaURL + blog.photo">
              <template v-slot:placeholder> <ImageLoader /> </template>
            </v-img>
          </v-card>
        </v-flex>
      </v-layout>
    </v-flex>
    <v-flex xs12 pt-8>
      <v-container style="font-family: robotolight">
        <span v-html="blog.description"></span>
      </v-container>
    </v-flex>
    <v-flex
      xs12
      style="background-color: #f8f8f8"
      pb-5
      py-md-12
      px-md-16
      px-lg-16
    >
      <v-layout wrap px-lg-10>
        <template 
          v-for="(item, i) in  blogList"
        >
        <v-flex
          py-2
          align-self-center
          text-center
          px-2
          px-lg-2
          xs12
          sm6
          md4
          v-if="item._id != blog._id"
          :key="i"
        >
          <v-card tile>
            <v-layout wrap style="font-family: robotoregular">
              <v-flex xs12>
                <v-img :src="mediaURL + item.photo">
                </v-img>
              </v-flex>

              <v-flex
                px-3
                px-md-5
                pt-3
                pt-md-5
                xs6
                text-left
                style="color: #ababab; font-size: 12px; font-family: sofiapro"
              >
                 {{ item.create_date.slice(0, 10) }}
              </v-flex>
              <v-flex
                px-3
                px-md-5
                xs12
                md10
                text-left
                style="font: 18px robotobold"
                pt-2
              >
               {{ item.heading }}
              </v-flex>
              <v-flex py-3 class="clr regulartext" px-3 px-md-5 xs12 text-left>
                {{ item.author }}
              </v-flex>
            </v-layout>
          </v-card>
        </v-flex>
        </template>
      </v-layout>
    </v-flex>
  </v-layout>
</template>
<script>
import axios from "axios";
export default {
  data() {
    return {
      items: ["m1", "m2", "m3"],
      blog: [],
      blogList:[],
      appLoading:false,
      lastItem: false,
      firstItem: false,
      blogLength: null,
      ServerError:false,
    };
  },
  beforeMount() {
    this.getData();
    this.getList();
  },
  methods: {
     show() {
      var newobj = {};
      if (this.blog._id == this.blogList[1]._id) {
        this.firstItem = true;
      }
      for (var i = 0; i < this.blogList.length; i++) {
        if (this.blog._id == this.blogList[i]._id) {
          if (i > 0) {
            newobj = this.blogList[i - 1];
            this.lastItem = false;
          }
        }
      }
      this.blog = newobj;
    },
    showImage() {
      var newobj = {};
      if (this.blog._id == this.blogList[this.blogLength - 2]._id) {
        this.lastItem = true;
      }
      for (var i = 0; i < this.blogList.length - 1; i++) {
        if (this.blog._id == this.blogList[i]._id) {
          this.firstItem = false;
          newobj = this.blogList[i + 1];
        }
      }

      this.blog = newobj;
    },
    getData() {
      this.appLoading = true;
      axios({
        method: "GET",
        url: "/blog/view/" + this.$route.query.blog,
        headers: {
          "x-auth-token": localStorage.getItem("token"),
        },
      })
        .then((response) => {
          if (response.data.status) {
            this.blog = response.data.data;
            this.appLoading = false;
          } else {
            this.msg = response.data.msg;
          }
        })
        .catch((err) => {
          this.appLoading = false;
          this.ServerError = true;
          console.log(err);
        });
    },
     getList() {
      this.appLoading = true;
      axios({
        method: "GET",
        url: "/blog/list",
        headers: {
          "x-auth-token": localStorage.getItem("token"),
        },
      })
        .then((response) => {
          if (response.data.status) {
            this.blogList = response.data.data;
            this.blogLength = response.data.data.length;
            if (this.blog) this.firstItem = true;
            this.pages = response.data.pages;
            this.appLoading = false;
          } else {
            this.msg = response.data.msg;
          }
        })
        .catch((err) => {
          this.appLoading = false;
          this.ServerError = true;
          console.log(err);
        });
    },
  },
};
</script>